import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import ProviderTaxYearPurchaseReportRepository from "~/repository/Provider/ProviderTaxYearPurchaseReportRepository";

class ProviderTaxYearPurchaseReportStore extends NestStore {
  /**
   * @property {number}
   */
  @observable amount = 0;

  /**
   * @property {ProviderTaxYearPurchaseReportRepository|null}
   */
  providerTaxYearPurchaseReportRepository = null;

  constructor() {
    super();

    this.providerTaxYearPurchaseReportRepository = new ProviderTaxYearPurchaseReportRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.providerTaxYearPurchaseReportRepository.fetchOne().then(response => {
      this.amount = response.data.providerTaxYearPurchaseReport;
    });
  }
}

export default ProviderTaxYearPurchaseReportStore;
